import { ElementRef } from '@angular/core';
import { FormArray, FormBuilder } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import { chain } from 'lodash';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var FcOutlinedMultiSelectComponent = /** @class */ (function () {
    function FcOutlinedMultiSelectComponent(elementRef, formBuilder, translateService, fuseTranslationLoaderService) {
        this.elementRef = elementRef;
        this.formBuilder = formBuilder;
        this.translateService = translateService;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.showOptions = false;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.allOption = {
            text: this.translateService.instant('FC_OUTLINED_MULTI_SELECT.ALL_OPTION'),
            value: { isAllOption: true }
        };
    }
    FcOutlinedMultiSelectComponent.prototype.onClickOutside = function (event) {
        var clickedInside = this.elementRef.nativeElement.contains(event.target);
        if (!clickedInside) {
            this.showOptions = false;
        }
    };
    FcOutlinedMultiSelectComponent.prototype.displayWith = function (value) {
        return chain(value).map('text').sortBy().value().join(', ');
    };
    FcOutlinedMultiSelectComponent.prototype.findIndexOfControl = function (option) {
        return this.control.controls.findIndex(function (control) { return control.value.text === option.text; });
    };
    FcOutlinedMultiSelectComponent.prototype.isSelected = function (option) {
        return this.findIndexOfControl(option) >= 0;
    };
    FcOutlinedMultiSelectComponent.prototype.selectOption = function (option, checkbox) {
        checkbox.checked = !checkbox.checked;
        var checked = checkbox.checked;
        this.updateFormArray({ option: option, checked: checked, isAll: false });
    };
    FcOutlinedMultiSelectComponent.prototype.selectAll = function (allOptionsCheckbox) {
        allOptionsCheckbox.checked = !allOptionsCheckbox.checked;
        this.updateFormArray({ option: this.allOption, checked: allOptionsCheckbox.checked, isAll: true });
    };
    FcOutlinedMultiSelectComponent.prototype.updateFormArray = function (_a) {
        var option = _a.option, checked = _a.checked, isAll = _a.isAll;
        if (!isAll) {
            this.removeOptionControl(this.allOption);
        }
        if (checked) {
            var optionControl = this.formBuilder.group({
                text: option.text,
                value: option.value
            });
            if (isAll) {
                this.control.clear();
            }
            this.control.push(optionControl);
            return;
        }
        this.removeOptionControl(option);
    };
    FcOutlinedMultiSelectComponent.prototype.removeOptionControl = function (option) {
        if (this.isSelected(option)) {
            var indexOfControl = this.findIndexOfControl(option);
            this.control.removeAt(indexOfControl);
        }
    };
    return FcOutlinedMultiSelectComponent;
}());
export { FcOutlinedMultiSelectComponent };
